/**
 * Generates Booking Confirmation email HTML for HomeGo Removals
 * Sent after customer accepts a quotation package
 */

// HomeGo logo
const SUNNY_IMAGE_URL = "https://customer-assets-gfyr7b9c.emergentagent.net/job_removals-quotation/artifacts/47umpr4g_WhatsApp%20Image%202026-07-18%20at%2021.43.15.jpeg";

export const generateConfirmationEmailHTML = (data) => {
  const {
    quotation_reference = "HG-00001",
    customer_name = "Customer",
    moving_from = "MK11 4BB",
    moving_to = "MK14 7BB",
    moving_date = "Friday, 6 March 2026",
    arrival_time = "8:00 AM - 9:00 AM",
    
    // Consultant
    consultant_name = "Thomas Jacobs",
    consultant_title = "Customer Consultant",
    consultant_image = SUNNY_IMAGE_URL,
    
    // Selected package
    selected_package = "Comfort Move",
    package_description = "Dismantling & reassembling furniture, Loading & unloading, Placing boxes in correct rooms",
    
    // Pricing
    service_total = 485,
    deposit_amount = 95,
    
    // Special notes
    special_notes = "",
    
    // Bank details
    bank_account_name = "HOMEGO REMOVALS & PACKING LTD",
    bank_sort_code = "23-05-80",
    bank_account_number = "57158107",
    
    // Payment link (optional)
    payment_link = "",
    
    // Crew Recommendation
    booked_crew_count = "",
    booked_van_type = "",
    recommended_crew_count = "",
    recommended_van_type = "",
    crew_upgrade_cost = "150",
    show_crew_recommendation = false,

    // Working Hours & Overtime Policy
    show_overtime_policy = false,
    overtime_rate = "120",
    work_hours_start = "9:00 AM",
    work_hours_end = "5:00 PM",
    
    // Multiple Locations
    pickup_location_1 = "",
    pickup_location_2 = "",
    dropoff_location_1 = "",
    dropoff_location_2 = "",
    stop_location_1 = "",
    stop_location_2 = "",
    show_extra_pickups = false,
    show_extra_dropoffs = false,
    show_stops = false,
    
    // Special Requirements
    special_requirements = "",
    show_special_requirements = false,
    
    // Custom Message
    custom_recommendation_message = "",
    show_custom_message = false,
  } = data;

  // Calculate totals (NO VAT)
  const totalAmount = service_total;
  const remainingBalance = totalAmount - deposit_amount;

  // Vehicle image URL
  const vehicleImageUrl = "https://customer-assets-gfyr7b9c.emergentagent.net/job_removals-quotation/artifacts/47umpr4g_WhatsApp%20Image%202026-07-18%20at%2021.43.15.jpeg";

  // Special notes section (only show if there are notes)
  const specialNotesHTML = special_notes ? `
    <!-- Special Notes -->
    <tr>
      <td style="padding: 0 40px 25px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FFFEF5; border: 2px solid #D4AF37; border-radius: 8px;">
          <tr>
            <td style="padding: 20px;">
              <h4 style="margin: 0 0 10px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #B8860B;">
                &#128221; Special Notes
              </h4>
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.6; white-space: pre-line;">
                ${special_notes}
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  ` : '';

  // Payment link button (only show if link provided)
  const paymentButtonHTML = payment_link ? `
    <!-- Pay by Card -->
    <tr>
      <td style="padding: 0 40px 25px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #E8F5E9; border: 1px solid #C8E6C9; border-radius: 8px;">
          <tr>
            <td style="padding: 25px; text-align: center;">
              <h4 style="margin: 0 0 10px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #2E7D32; text-transform: uppercase; letter-spacing: 1px;">
                &#128179; PAY BY CARD
              </h4>
              <p style="margin: 0 0 20px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.5;">
                Prefer to pay by debit or credit card?<br/>
                Click the button below to pay your deposit securely online.
              </p>
              <table border="0" cellpadding="0" cellspacing="0" align="center">
                <tr>
                  <td style="background-color: #2196F3; border-radius: 6px;">
                    <a href="${payment_link}" target="_blank" style="display: inline-block; padding: 15px 40px; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; color: #FFFFFF; text-decoration: none;">
                      Pay Deposit Now
                    </a>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  ` : '';

  // Crew Recommendation section (only show if enabled)
  // Working Hours & Overtime Policy section (only show if enabled)
  const overtimePolicyHTML = show_overtime_policy ? `
          <!-- Working Hours & Overtime Policy -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border-radius: 12px; overflow: hidden; border: 2px solid #1a1a1a;">
                <tr>
                  <td style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); padding: 15px 20px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 15px; font-weight: bold; color: #D4AF37; text-transform: uppercase; letter-spacing: 1px;">
                      ⏰ Working Hours &amp; Overtime Policy
                    </h3>
                  </td>
                </tr>
                <tr>
                  <td style="background-color: #FAFAF7; padding: 20px;">
                    <p style="margin: 0 0 12px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.7;">
                      Our crew's standard working day runs from <strong>${work_hours_start}</strong> to <strong>${work_hours_end}</strong>, in line with UK working practice for removals crews.
                    </p>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FEF2F2; border: 1px solid #FCA5A5; border-radius: 8px;">
                      <tr>
                        <td style="padding: 12px 15px;">
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #991B1B; line-height: 1.6;">
                            <strong>Overtime:</strong> Any work required after ${work_hours_end} is chargeable at <strong style="font-size: 16px;">£${overtime_rate} per hour</strong> (or part thereof), payable on the day.
                          </p>
                        </td>
                      </tr>
                    </table>
                    <p style="margin: 12px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 13px; color: #065F46; line-height: 1.6; background-color: #ECFDF5; border-radius: 8px; padding: 12px 15px;">
                      💡 <strong>Avoid overtime charges:</strong> booking the recommended crew size means your move completes comfortably within standard hours — faster, smoother, and no extra cost on the day.
                    </p>
                    <p style="margin: 12px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #888; line-height: 1.5;">
                      By confirming your booking you accept these working hours and overtime terms, which form part of your agreement with HomeGo Removals &amp; Packing Ltd.
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
  ` : '';

  const crewRecommendationHTML = show_crew_recommendation && booked_crew_count ? `
    <!-- Crew Upgrade Recommendation -->
    <tr>
      <td style="padding: 0 40px 25px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FEF3C7; border: 2px solid #F59E0B; border-radius: 8px;">
          <tr>
            <td style="padding: 20px;">
              <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #92400E; text-transform: uppercase; letter-spacing: 1px;">
                &#128666; Crew Upgrade Recommendation
              </h4>
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="padding: 10px; background-color: #FFF; border-radius: 6px; margin-bottom: 10px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333;">
                      <strong>Your Current Booking:</strong><br/>
                      ${booked_crew_count} Crew Members + ${booked_van_type}
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 10px; background-color: #D1FAE5; border-radius: 6px; margin-top: 10px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #065F46;">
                      <strong>&#128161; For a faster & smoother move we recommend:</strong><br/>
                      ${recommended_crew_count} Crew Members + ${recommended_van_type}
                    </p>
                    <p style="margin: 10px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; color: #047857;">
                      Extra Cost: +£${crew_upgrade_cost}
                    </p>
                    <p style="margin: 10px 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #047857;">
                      ⏱️ Save time & reduce stress with extra help!
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  ` : '';

  // Multiple Locations HTML
  const hasExtraLocations = (show_extra_pickups && (pickup_location_1 || pickup_location_2)) || 
                           (show_extra_dropoffs && (dropoff_location_1 || dropoff_location_2)) ||
                           (show_stops && (stop_location_1 || stop_location_2));
  
  const multipleLocationsHTML = hasExtraLocations ? `
    <!-- Multiple Locations -->
    <tr>
      <td style="padding: 0 40px 25px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FFF7ED; border: 2px solid #F97316; border-radius: 8px;">
          <tr>
            <td style="padding: 20px;">
              <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #C2410C; text-transform: uppercase; letter-spacing: 1px;">
                📍 Multiple Locations
              </h4>
              
              ${show_extra_pickups && (pickup_location_1 || pickup_location_2) ? `
              <div style="margin-bottom: 15px;">
                <p style="margin: 0 0 8px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; color: #EA580C;">PICKUP LOCATIONS:</p>
                <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                  <strong>1.</strong> ${moving_from} (Main)<br/>
                  ${pickup_location_1 ? `<strong>2.</strong> ${pickup_location_1}<br/>` : ''}
                  ${pickup_location_2 ? `<strong>3.</strong> ${pickup_location_2}<br/>` : ''}
                </p>
              </div>
              ` : ''}
              
              ${show_extra_dropoffs && (dropoff_location_1 || dropoff_location_2) ? `
              <div style="margin-bottom: 15px;">
                <p style="margin: 0 0 8px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; color: #EA580C;">DROP-OFF LOCATIONS:</p>
                <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                  <strong>1.</strong> ${moving_to} (Main)<br/>
                  ${dropoff_location_1 ? `<strong>2.</strong> ${dropoff_location_1}<br/>` : ''}
                  ${dropoff_location_2 ? `<strong>3.</strong> ${dropoff_location_2}<br/>` : ''}
                </p>
              </div>
              ` : ''}
              
              ${show_stops && (stop_location_1 || stop_location_2) ? `
              <div>
                <p style="margin: 0 0 8px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; color: #EA580C;">STOPS ALONG THE WAY:</p>
                <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                  ${stop_location_1 ? `<strong>Stop 1:</strong> ${stop_location_1}<br/>` : ''}
                  ${stop_location_2 ? `<strong>Stop 2:</strong> ${stop_location_2}<br/>` : ''}
                </p>
              </div>
              ` : ''}
            </td>
          </tr>
        </table>
      </td>
    </tr>
  ` : '';

  // Special Requirements HTML
  const specialRequirementsHTML = show_special_requirements && special_requirements ? `
    <!-- Special Requirements -->
    <tr>
      <td style="padding: 0 40px 25px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FFF1F2; border: 2px solid #F43F5E; border-radius: 8px;">
          <tr>
            <td style="padding: 20px;">
              <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #BE123C; text-transform: uppercase; letter-spacing: 1px;">
                ⚠️ Special Requirements
              </h4>
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.7; white-space: pre-line;">
                ${special_requirements}
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  ` : '';

  // Custom Message section (only show if enabled and has content)
  const customMessageHTML = show_custom_message && custom_recommendation_message ? `
    <!-- Personal Message from HomeGo -->
    <tr>
      <td style="padding: 0 40px 25px;">
        <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F3E8FF; border: 2px solid #9333EA; border-radius: 8px;">
          <tr>
            <td style="padding: 20px;">
              <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #7C3AED; text-transform: uppercase; letter-spacing: 1px;">
                &#128172; A Message From Our Team
              </h4>
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.7; white-space: pre-line;">
                ${custom_recommendation_message}
              </p>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  ` : '';

  return `
<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
<html xmlns="http://www.w3.org/1999/xhtml">
<head>
  <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />
  <title>Booking Confirmation - ${quotation_reference}</title>
  <style type="text/css">
    /* Mobile Responsive Styles */
    @media only screen and (max-width: 620px) {
      .email-container { width: 100% !important; }
      .mobile-padding { padding-left: 15px !important; padding-right: 15px !important; }
      .mobile-stack { display: block !important; width: 100% !important; }
      .mobile-center { text-align: center !important; }
      .mobile-font-large { font-size: 26px !important; }
      .header-padding { padding: 20px !important; }
      .content-padding { padding: 15px !important; }
    }
  </style>
</head>
<body style="margin: 0; padding: 0; background-color: #F4F4F5; font-family: Helvetica, Arial, sans-serif;">
  <!-- Main Container -->
  <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #F4F4F5;">
    <tr>
      <td align="center" style="padding: 20px 10px;">
        <!-- Email Container -->
        <table class="email-container" border="0" cellpadding="0" cellspacing="0" width="600" style="max-width: 600px; width: 100%; background-color: #FFFFFF; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);">
          
          <!-- Header -->
          <tr>
            <td style="padding: 30px 40px; text-align: center;">
              <h1 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 32px; font-weight: bold; color: #D4AF37; letter-spacing: 1px;">
                HOME<span style="color: #000000;">GO</span> REMOVALS
              </h1>
            </td>
          </tr>

          <!-- Booking Confirmed Banner -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #4CAF50; border-radius: 8px;">
                <tr>
                  <td style="padding: 20px; text-align: center;">
                    <h2 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 24px; font-weight: bold; color: #FFFFFF;">
                      &#10004; Booking Confirmed!
                    </h2>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Greeting -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <p style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 16px; color: #333333;">
                Dear <strong>${customer_name.toUpperCase()}</strong>,
              </p>
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #666666; line-height: 1.6;">
                We're delighted to confirm your booking with HomeGo Removals. Our team will arrive between <strong>${arrival_time}</strong> on your moving day.
              </p>
            </td>
          </tr>

          <!-- Your Move Details -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border: 2px solid #D4AF37; border-radius: 8px; overflow: hidden;">
                <!-- Header -->
                <tr>
                  <td style="background-color: #000000; padding: 12px 20px;">
                    <h3 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #D4AF37; text-transform: uppercase; letter-spacing: 1px;">
                      &#128197; YOUR MOVE DETAILS
                    </h3>
                  </td>
                </tr>
                <!-- Body -->
                <tr>
                  <td style="padding: 20px;">
                    <!-- Moving Date -->
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 20px;">
                      <tr>
                        <td>
                          <p style="margin: 0 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #999999; text-transform: uppercase; letter-spacing: 1px;">
                            MOVING DATE
                          </p>
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; color: #000000;">
                            ${moving_date}
                          </p>
                        </td>
                      </tr>
                    </table>

                    <!-- From / To -->
                    <table border="0" cellpadding="0" cellspacing="0" width="100%" style="margin-bottom: 20px;">
                      <tr>
                        <td style="width: 45%;">
                          <p style="margin: 0 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #999999;">
                            &#128205; FROM
                          </p>
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; color: #000000;">
                            ${moving_from}
                          </p>
                        </td>
                        <td style="width: 10%; text-align: center;">
                          <span style="font-size: 20px; color: #D4AF37;">&#10132;</span>
                        </td>
                        <td style="width: 45%;">
                          <p style="margin: 0 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #999999;">
                            &#128205; TO
                          </p>
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; color: #000000;">
                            ${moving_to}
                          </p>
                        </td>
                      </tr>
                    </table>

                    <!-- Service Package -->
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <p style="margin: 0 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #999999; text-transform: uppercase; letter-spacing: 1px;">
                            SERVICE PACKAGE
                          </p>
                          <p style="margin: 0 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; color: #000000;">
                            ${selected_package}
                          </p>
                          <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 13px; color: #666666;">
                            ${package_description}
                          </p>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          ${specialNotesHTML}

          ${multipleLocationsHTML}

          ${specialRequirementsHTML}

          ${crewRecommendationHTML}

          ${overtimePolicyHTML}

          ${customMessageHTML}

          <!-- Payment Summary -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #000000; border-radius: 8px; overflow: hidden;">
                <tr>
                  <td style="padding: 15px 20px;">
                    <h4 style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #D4AF37; text-transform: uppercase; letter-spacing: 1px;">
                      &#128179; PAYMENT SUMMARY
                    </h4>
                  </td>
                </tr>
                <tr>
                  <td style="padding: 0 20px 20px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 15px 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; color: #D4AF37;">
                          Total Amount
                        </td>
                        <td style="padding: 15px 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 20px; font-weight: bold; color: #C62828; text-align: right;">
                          &pound;${totalAmount.toFixed(2)}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Deposit Required -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #FFEBEE; border: 2px solid #FFCDD2; border-radius: 8px;">
                <tr>
                  <td style="padding: 25px; text-align: center;">
                    <p style="margin: 0 0 10px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #C62828; text-transform: uppercase; letter-spacing: 1px;">
                      DEPOSIT REQUIRED
                    </p>
                    <p style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 36px; font-weight: bold; color: #C62828;">
                      &pound;${deposit_amount.toFixed(2)}
                    </p>
                    <p style="margin: 0 0 10px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.5;">
                      To secure your booking, please pay the deposit using the bank details below.
                    </p>
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #C62828;">
                      Please reply to this email once payment is made.
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Bank Details -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background-color: #E8F5E9; border: 1px solid #C8E6C9; border-radius: 8px;">
                <tr>
                  <td style="padding: 20px;">
                    <h4 style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; font-weight: bold; color: #2E7D32; text-transform: uppercase; letter-spacing: 1px;">
                      &#127974; BANK DETAILS
                    </h4>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #666666; width: 40%;">
                          Account Name:
                        </td>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #000000; font-weight: bold; text-align: right;">
                          ${bank_account_name}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #666666;">
                          Sort Code:
                        </td>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #000000; font-weight: bold; text-align: right;">
                          ${bank_sort_code}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #666666;">
                          Account Number:
                        </td>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #000000; font-weight: bold; text-align: right;">
                          ${bank_account_number}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #666666;">
                          Reference:
                        </td>
                        <td style="padding: 8px 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #000000; font-weight: bold; text-align: right;">
                          ${customer_name}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          ${paymentButtonHTML}

          <!-- Remaining Balance Note -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="border-left: 4px solid #D4AF37; padding-left: 15px;">
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.6;">
                      &#128161; The remaining balance of <strong>&pound;${remainingBalance.toFixed(2)}</strong> can be paid via bank transfer the day before, or in cash on moving day morning before the team begins work.
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Date Change Note -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.6;">
                &#128197; <strong>Need to change your date?</strong> No problem! Date changes are free of charge with at least 12 hours notice.
              </p>
            </td>
          </tr>

          <!-- Closing Message -->
          <tr>
            <td style="padding: 0 40px 25px;">
              <p style="margin: 0 0 15px; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333; line-height: 1.6;">
                We look forward to making your move as smooth as possible!
              </p>
              <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 14px; color: #333333;">
                Kind regards,
              </p>
            </td>
          </tr>

          <!-- Consultant Section - Thomas Jacobs with Meta-style Verified Badge -->
          <tr>
            <td style="padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="border: 2px solid #E5E7EB; border-radius: 12px; overflow: hidden;">
                <tr>
                  <td style="padding: 20px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="width: 75px; vertical-align: top;">
                          <img src="${consultant_image}" alt="${consultant_name}" width="80" style="width: 80px; height: auto; border-radius: 8px; border: 2px solid #D4AF37; background-color: #FFFFFF; display: block;" />
                        </td>
                        <td style="vertical-align: top; padding-left: 12px;">
                          <p style="margin: 0 0 4px; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; color: #000000;">
                            ${consultant_name}
                            <img src="https://upload.wikimedia.org/wikipedia/commons/e/e4/Twitter_Verified_Badge.svg" alt="Verified" width="16" height="16" style="width: 16px; height: 16px; vertical-align: middle; margin-left: 4px;" />
                          </p>
                          <p style="margin: 0 0 10px; font-family: Helvetica, Arial, sans-serif; font-size: 12px; color: #666666;">
                            ${consultant_title}
                          </p>
                          <a href="tel:07440414548" style="display: inline-block; background-color: #D4AF37; color: #000000; font-family: Helvetica, Arial, sans-serif; font-size: 12px; font-weight: bold; text-decoration: none; padding: 6px 14px; border-radius: 15px;">
                            📞 Call Thomas
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

          <!-- Vehicle Image (Small) -->
          <tr>
            <td style="padding: 0 40px 30px;" align="center">
              <img src="${vehicleImageUrl}" alt="HomeGo Removals Logo" style="width: 320px; max-width: 100%; height: auto; display: block;" />
            </td>
          </tr>

          <!-- Footer -->
          <tr>
            <td style="background-color: #000000; padding: 25px 40px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <h4 style="margin: 0 0 5px; font-family: Helvetica, Arial, sans-serif; font-size: 18px; font-weight: bold; color: #D4AF37;">
                      HomeGo Removals &amp; Packing Ltd
                    </h4>
                    <p style="margin: 0 0 12px; font-family: Helvetica, Arial, sans-serif; font-size: 11px; color: #999999;">
                      Registered in England and Wales Company No. <span style="color: #D4AF37;">16811153</span>
                    </p>
                    <!-- Social + Contact Row -->
                    <table border="0" cellpadding="0" cellspacing="0" style="margin-bottom: 12px;">
                      <tr>
                        <td style="padding: 0 6px;">
                          <a href="https://facebook.com/homegoremovals" target="_blank"><img src="https://cdn-icons-png.flaticon.com/32/733/733547.png" alt="Facebook" width="20" height="20" /></a>
                        </td>
                        <td style="padding: 0 6px;">
                          <a href="https://instagram.com/homegoremovals" target="_blank"><img src="https://cdn-icons-png.flaticon.com/32/733/733558.png" alt="Instagram" width="20" height="20" /></a>
                        </td>
                        <td style="padding: 0 10px; color: #444;">|</td>
                        <td style="padding: 0 4px;">
                          <a href="https://wa.me/447440414548" style="display: inline-block; background-color: #25D366; color: #FFFFFF; font-family: Helvetica, Arial, sans-serif; font-size: 10px; font-weight: bold; text-decoration: none; padding: 5px 10px; border-radius: 12px;">💬 WhatsApp</a>
                        </td>
                        <td style="padding: 0 4px;">
                          <a href="tel:07440414548" style="display: inline-block; background-color: #D4AF37; color: #000000; font-family: Helvetica, Arial, sans-serif; font-size: 10px; font-weight: bold; text-decoration: none; padding: 5px 10px; border-radius: 12px;">📞 Call Thomas</a>
                        </td>
                      </tr>
                    </table>
                    <p style="margin: 0; font-family: Helvetica, Arial, sans-serif; font-size: 10px; color: #666666;">
                      &copy; HomeGo Removals &amp; Packing Ltd. All rights reserved.
                    </p>
                    <!-- Physical Address -->
                    <p style="margin: 10px 0 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 10px; color: #888888;">
                      HomeGo Removals &amp; Packing Ltd | UK's Nationwide Premium Moving Company | Tel: 0330 043 4791
                    </p>
                    <!-- Unsubscribe -->
                    <p style="margin: 10px 0 0 0; font-family: Helvetica, Arial, sans-serif; font-size: 9px; color: #999999;">
                      This email confirms your booking. Reply with "unsubscribe" to stop receiving emails.
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>

        </table>
        <!-- End Email Container -->
      </td>
    </tr>
  </table>
  <!-- End Main Container -->
</body>
</html>
`;
};

export default generateConfirmationEmailHTML;
